var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileIcMemo = function SvgFileIcMemo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EAB308",
    d: "M12.667 4.666H10V2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAB308",
    fillRule: "evenodd",
    d: "M8.078 1.339 8 1.334H4.667l-.118.003a2 2 0 0 0-1.882 1.997V8H6.4a2.4 2.4 0 0 1 2.4 2.4v4.267h2.534l.117-.003a2 2 0 0 0 1.883-1.997v-6l-.005-.078a.666.666 0 0 0-.584-.584l-.078-.004H10l-.105-.004a1.33 1.33 0 0 1-1.225-1.23l-.003-.1V2.001l-.005-.078a.67.67 0 0 0-.584-.584",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EAB308",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M2.4 10.4v4.146m3.843-3.11a1.037 1.037 0 0 0-2.073 0v2.073a1.036 1.036 0 1 0 2.073 0"
  })));
};
export default SvgFileIcMemo;